document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
         let priceTemplates = document.querySelectorAll(".price-ui .price[data-price]")
  let priceBlock = document.querySelector(".shopify-app-block .price")

  if (priceBlock && !priceBlock.classList.contains("hide")) {
    for (const priceTemplate of priceTemplates) {
      priceTemplate.style.display = "none"
    }
  } 
    }, 800);

    setTimeout(() => {
         let priceTemplates = document.querySelectorAll(".price-ui .price[data-price]")
  let priceBlock = document.querySelector(".shopify-app-block .price")

  if (priceBlock && !priceBlock.classList.contains("hide")) {
    for (const priceTemplate of priceTemplates) {
      priceTemplate.style.display = "none"
    }
  } 
    }, 1300);
})